/**
 * Chuẩn hoá chữ tự do khách gõ để nhắn tiệm (0035, phản ánh 25/09).
 *
 * Trần 300 ký tự đã có ở cả ba lớp, nhưng 300 ký tự **toàn dấu xuống dòng** vẫn lọt và thành một
 * lời nhắn cao 300 dòng trên tờ chi tiết lịch — nút "Khách đã tới" bị đẩy xuống tận đáy. Hàm này
 * chạy ở máy chủ (chốt) và ở Mini App (để khách thấy đúng cái sẽ gửi); DB có CHECK số dòng (0043).
 *
 * Việc làm, theo thứ tự:
 *   1. `\r\n` / `\r` → `\n`, tab → dấu cách;
 *   2. bỏ ký tự điều khiển và ký tự vô hình (zero-width, đảo chiều chữ) — chúng không mang nghĩa
 *      gì với tiệm mà dùng được để giả mạo hoặc làm vỡ giao diện;
 *   3. cắt khoảng trắng cuối mỗi dòng, gộp các dòng trống liên tiếp thành một, bỏ dòng trống đầu/cuối;
 *   4. quá `LOI_NHAN_TOI_DA_DONG` dòng thì phần thừa nối bằng dấu cách vào dòng cuối — không mất chữ.
 *
 * Hàm idempotent: chuẩn hoá hai lần ra đúng kết quả lần một (có property test).
 */
export const LOI_NHAN_TOI_DA_KY_TU = 300
export const LOI_NHAN_TOI_DA_DONG = 6

/** Ký tự bị bỏ: điều khiển C0/C1 (trừ `\n`), zero-width, đảo chiều chữ, BOM. */
function laKyTuAn(cp: number): boolean {
  if (cp === 0x0a) return false
  return (
    cp <= 0x1f ||
    (cp >= 0x7f && cp <= 0x9f) ||
    (cp >= 0x200b && cp <= 0x200f) ||
    cp === 0x2028 ||
    cp === 0x2029 ||
    (cp >= 0x202a && cp <= 0x202e) ||
    (cp >= 0x2060 && cp <= 0x2064) ||
    (cp >= 0x2066 && cp <= 0x2069) ||
    cp === 0xfeff ||
    // Soát bảo mật 25/09: gạch nối mềm, ký tự nối vô hình, "chữ trống" Hangul, khối Tag.
    cp === 0x00ad ||
    cp === 0x034f ||
    cp === 0x115f ||
    cp === 0x1160 ||
    cp === 0x180e ||
    cp === 0x3164 ||
    cp === 0xffa0 ||
    (cp >= 0xe0000 && cp <= 0xe007f)
  )
}

export function chuanHoaLoiNhan(vao: string): string {
  let sach = ''
  for (const ch of vao.replace(/\r\n?/g, '\n').replace(/\t/g, ' ')) {
    const cp = ch.codePointAt(0)
    if (cp !== undefined && !laKyTuAn(cp)) sach += ch
  }

  const dong: string[] = []
  for (const d of sach.split('\n')) {
    const gon = d.trimEnd()
    // Gộp dòng trống liên tiếp, và không mở đầu bằng dòng trống.
    if (gon.trim() === '' && (dong.length === 0 || dong[dong.length - 1] === '')) continue
    dong.push(gon.trim() === '' ? '' : gon)
  }
  while (dong.length > 0 && dong[dong.length - 1] === '') dong.pop()

  if (dong.length > LOI_NHAN_TOI_DA_DONG) {
    const giu = dong.slice(0, LOI_NHAN_TOI_DA_DONG - 1)
    const thua = dong
      .slice(LOI_NHAN_TOI_DA_DONG - 1)
      .map((d) => d.trim())
      .filter((d) => d !== '')
      .join(' ')
    giu.push(thua)
    return giu.join('\n').trim()
  }
  return dong.join('\n').trim()
}

/** Số dòng của một lời nhắn đã chuẩn hoá (để kiểm và để giao diện quyết định có "Xem thêm"). */
export function soDongLoiNhan(s: string): number {
  return s === '' ? 0 : s.split('\n').length
}
